import React from 'react';
import Entries from '../../components/Entries/Entries';

const EntriesView = () => <Entries />

export default EntriesView;
